import { ColumnsType } from 'antd/es/table';
import { Button } from 'antd';
import { ReactComponent as Edit } from 'assets/icons/edit.svg';
import { ReactComponent as Remove } from 'assets/icons/remove.svg';
import { getDate } from 'common/utils';
import { Job } from 'types/job';

export const JobColumns = (
  editCallback: (item: Job) => void,
  deleteCallback: (item: Job) => void,
): ColumnsType<Job> => ([
  {
    title: 'Job Title',
    dataIndex: 'jobTitle',
    fixed: true
  },
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Company',
    dataIndex: 'company',
  },
  {
    title: 'Location',
    dataIndex: 'location',
  },
  {
    title: 'Posting Date',
    dataIndex: 'postingDate',
    render: (_, record) => getDate(record.createdAt)
  },
  {
    title: 'Last Modified',
    dataIndex: 'lastModified',
    render: (_, record) => getDate(record.updatedAt)
  },
  {
    title: 'Rank',
    dataIndex: 'rank',
  },
  {
    title: 'Actions',
    key: 'action',
    render: (_, item) => (
      <div className="actions-wrapper">
        <Button type="text" icon={<Edit className="edit" />} onClick={() => editCallback(item)} />
        <Button type="text" icon={<Remove className="remove" />} onClick={() => deleteCallback(item)} />
      </div>
    ),
    width: '80px',
    fixed: 'right'
  }
]);
